import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function Unsubscribe() {
  const [status, setStatus] = useState('loading') // loading | success | notfound | error
  const email = new URLSearchParams(window.location.search).get('email')

  useEffect(() => {
    if (!email) { setStatus('notfound'); return }
    async function unsub() {
      const { error } = await supabase.from('subscribers')
        .update({ active: false })
        .eq('email', email.trim().toLowerCase())
      setStatus(error ? 'error' : 'success')
    }
    unsub()
  }, [email])

  return (
    <div className="subscribe-screen">
      <div className="subscribe-box">
        <div className="subscribe-logo">
          <span className="login-triangle">▲</span>
          <span className="login-wordmark">INSIDE MAG</span>
        </div>
        {status === 'loading' && <p className="subscribe-tagline">Unsubscribing…</p>}
        {status === 'success' && (
          <div className="subscribe-success">
            <p>You've been unsubscribed.</p>
            <p className="subscribe-success-sub">{email}</p>
          </div>
        )}
        {status === 'notfound' && <p className="subscribe-error">No email address provided.</p>}
        {status === 'error' && <p className="subscribe-error">Something went wrong — email us to be removed.</p>}
      </div>
    </div>
  )
}
